import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import UpcomingTable from "./UpcomingTable";
import { MentorQueuesData } from "../../types";
import { loadUpcomingMentors, beginSession } from "../../redux/actions/guideStreamActions";
import Loading from "../../../Shared/loading";
import { ActiveSessionStub } from "../../../Shared/GeneratedTypes";
import useInterval from "../../../Shared/useInterval";

const mapState = ({ localizations, apiCallsInProgress, upcomingMentors }: MentorQueuesData) => ({
    upcomingMentors,
    localizations: localizations!,
    apiCallsInProgress,
});

const mapDispatch = {
    loadUpcomingMentors,
    beginSession,
};
const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;
type PropTypes = PropsFromRedux & {};

function UpcomingPage({
    upcomingMentors,
    loadUpcomingMentors,
    localizations,
    beginSession,
    apiCallsInProgress,
}: PropTypes) {
    // const { queuedMentors, loadQueuedMentors } = props;
    useEffect(() => {
        if (!upcomingMentors || upcomingMentors.length === 0) {
            loadUpcomingMentors();
        }
    }, []);

    const [secondsUntilRefresh, updateSecondsUntilRefresh] = useState(30);

    useInterval(() => {
        if (secondsUntilRefresh === 0) {
            loadUpcomingMentors();
            updateSecondsUntilRefresh(30);
        } else {
            updateSecondsUntilRefresh(secondsUntilRefresh - 1);
        }
    }, 1000);

    const refreshNow = () => {
        loadUpcomingMentors();
        updateSecondsUntilRefresh(30);
    };
    function selectMentor(session: ActiveSessionStub) {
        beginSession(session.customerId, session.id!);
    }
    return (
        <>
            {apiCallsInProgress > 0 ? (
                <>
                    <Loading message={localizations.loadingMentors} />
                </>
            ) : (
                <UpcomingTable
                    refreshNow={refreshNow}
                    refreshTimer={secondsUntilRefresh}
                    upcomingSessions={upcomingMentors}
                    localizations={localizations}
                    setActive={selectMentor}
                />
            )}
        </>
    );
}

export default connector(UpcomingPage);
